import {
  createBaseAsyncHandlers,
  createFailAction,
  createStartAction,
  createSuccessAction,
  initialState,
  makeDataUpdater,
} from '../redux-util/async-helpers';
import { GET_DEVICES, DEACTIVATE_DEVICE } from './jigsaw-methods';
import { createReducer } from '../redux-util/general-helpers';
import { removeAtIndex } from '../../utils/array';
import arrayFindIndex from 'array-find-index';

const emptyArray = [];

function doDeactivateStart(state, action) {
  const index = arrayFindIndex(state.devices, e => e.id === action.data[0]);
  if (index >= 0) {
    const toDeactivate = state.devices[index];
    const devices = removeAtIndex(state.devices, index);
    const deletes = state.pendingDeactivations || emptyArray;
    return {
      ...state,
      devices,
      pendingDeactivations: [...deletes, toDeactivate],
    };
  }
  return state;
}

function removePendingDeactivation(state, action) {
  return state.pendingDeactivations.filter(k => k.guid !== action.args[0]);
}

function doDeactivateSuccess(state, action) {
  return {
    ...state,
    pendingDeactivations: removePendingDeactivation(state, action),
  };
}

function doDeactivateFail(state, action) {
  const failedItem = state.pendingDeactivations.filter(
    d => d.id === action.args[0]
  )[0];

  return {
    ...state,
    devices: [...state.devices, failedItem],
    pendingDeactivations: removePendingDeactivation(state, action),
  };
}

const deactivateStart = createStartAction(DEACTIVATE_DEVICE).type;
const deactivateSuccess = createSuccessAction(DEACTIVATE_DEVICE).type;
const deactivateFail = createFailAction(DEACTIVATE_DEVICE).type;

const base = createBaseAsyncHandlers(GET_DEVICES);
const extras = {
  [deactivateStart]: makeDataUpdater(doDeactivateStart),
  [deactivateSuccess]: makeDataUpdater(doDeactivateSuccess),
  [deactivateFail]: makeDataUpdater(doDeactivateFail),
};

export default createReducer(initialState, base, extras);



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/devices-reducer.js